import { render, staticRenderFns } from "./DetalhesItensDoLote.vue?vue&type=template&id=5e024762"
import script from "./DetalhesItensDoLote.vue?vue&type=script&lang=ts"
export * from "./DetalhesItensDoLote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports